import { createSynchronousCache, updateSynchronousCache } from 'shared-code/cache'

export const generateAdPlacementIndex = (
  identifier: string,
  minIndex: number,
  maxIndex: number
): number => {
  const lastAdPlacementData = createSynchronousCache(identifier, {
    [identifier]: minIndex,
  })
  const currentPlacementId = lastAdPlacementData[identifier]

  if (lastAdPlacementData[identifier] >= maxIndex) {
    lastAdPlacementData[identifier] = minIndex
  } else {
    lastAdPlacementData[identifier]++
  }

  updateSynchronousCache(identifier, {
    [identifier]: lastAdPlacementData[identifier],
  })
  return currentPlacementId
}
